module.exports = __webpack_public_path__ + "static/don23-48a18399391026296ac6e85977e1ecfa.jpg";